import { ComponentPropsWithoutRef, ForwardedRef, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface NodeBadgesContainerProps extends ComponentPropsWithoutRef<'div'> {}
const NodeBadgesContainer = forwardRef(
    (
        { className, ...restProps }: NodeBadgesContainerProps,
        forwardedRef: ForwardedRef<HTMLDivElement>,
    ) => {
        return (
            <div
                className={twMerge('flex flex-wrap items-center justify-start gap-1.5', className)}
                ref={forwardedRef}
                {...restProps}
            />
        );
    },
);
NodeBadgesContainer.displayName = 'NodeBadgesContainer';

interface NodeBadgesBadgeProps extends ComponentPropsWithoutRef<'div'> {}
const NodeBadgesBadge = forwardRef(
    (
        { className, ...restProps }: NodeBadgesBadgeProps,
        forwardedRef: ForwardedRef<HTMLDivElement>,
    ) => {
        return (
            <div
                className={twMerge(
                    'font-regular block rounded-md border border-gray-300 bg-white px-2.5 py-1.5 text-sm text-gray-500 shadow-sm',
                    className,
                )}
                ref={forwardedRef}
                {...restProps}
            />
        );
    },
);
NodeBadgesBadge.displayName = 'NodeBadgesBadge';

interface NodeBadgeSeparatorProps extends ComponentPropsWithoutRef<'div'> {}
const NodeBadgeSeparator = forwardRef(
    (
        { className, ...restProps }: NodeBadgeSeparatorProps,
        forwardedRef: ForwardedRef<HTMLDivElement>,
    ) => {
        return <div className={twMerge('text-sm', className)} ref={forwardedRef} {...restProps} />;
    },
);
NodeBadgeSeparator.displayName = 'NodeBadgeSeparator';

const Root = NodeBadgesContainer;
const Badge = NodeBadgesBadge;
const Separator = NodeBadgeSeparator;

export {
    NodeBadgesContainer,
    NodeBadgesBadge,
    NodeBadgeSeparator,
    //
    Root,
    Badge,
    Separator,
};

export type { NodeBadgesContainerProps, NodeBadgesBadgeProps };
